export default "__VITE_ASSET__BN0l39TS__"